/* ══════════════ Die Fassung dieser Oberfläche ══════════════
   Beim Bauen eingesetzt (`vite.config.ts`, `define`). Nichts davon wird zur
   Laufzeit erfragt: Die Anmeldemaske muss sie zeigen, bevor es eine Sitzung
   gibt — und wer einen Fehler meldet, soll die Fassung nennen können, auch
   wenn die API gerade nicht antwortet. */

declare const __FASSUNG__: {
  /** `V26.09.16` — das Datum des Stands (30-monorepo.md, Abschnitt 5). */
  version: string | null;
  /** `dev`, `pre-production` … */
  zweig: string | null;
  /** Die ersten sieben Zeichen des Commits. */
  sha: string | null;
  /**
   * Die Kennung dieses Baus — Commit und Bauzeit (19.09.2026). Dieselbe steht
   * in `sw.js`; ist die eines wartenden Service Workers eine andere, ist diese
   * Seite alt (`pwa/anmelden.ts`, `vite.config.ts`).
   */
  bau: string;
};

export const FASSUNG = __FASSUNG__;
